<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="mypooq-info-body">
        <like-list viewMode="program" :showRecommend="showRecommend"/>
        <recommend-program v-if="isShowRecommend"/>
      </div>
    </section>
  </div>
</template>

<script>
import LikeList from '@/components/mypooq/LikeList'
import RecommendProgram from '@/components/mypooq/RecommendProgram'

export default {
  components: {
    LikeList,
    RecommendProgram
  },
  data () {
    return {
      isShowRecommend: false
    }
  },
  methods: {
    showRecommend () {
      this.isShowRecommend = true
    }
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
<style lang="css" src="@/assets/css/mypooq.css"></style>
<style lang="css">
.mypooq .mypooq-info-body{
  padding-bottom: 0;
}
</style>
